module.exports = __webpack_public_path__ + "img/7.d44222a2.jpg";